<template>
    <div class="app-dashboard">
        <div class="mb-4">
            <h4 class="mb-2">Tableau de bord</h4>
            <span class="font-semibold">Bonjour {{ activeUserInfo.displayName }}.</span>
            <span> Bienvenue sur votre tableau de bord</span>
        </div>
        <CCDashboard v-if="$store.state.is_chargerClientele()"></CCDashboard>
        <ClientDashboard v-if="$store.state.is_client() || $store.state.is_mandataire()"></ClientDashboard>
        <ManagerDashboard v-if="$store.state.is_manager()"></ManagerDashboard>
        <AdminDashboard v-if="$store.state.is_admin()"></AdminDashboard>
        <dispatcher-dashboard v-if="$store.state.is_dispatcher()"></dispatcher-dashboard>
        <commercial-dashboard v-if="$store.state.is_commercial()"></commercial-dashboard>

    </div>

</template>
<script>
    import CCDashboard from './components/CCDashboard';
    import ClientDashboard from './components/ClientDashboard';
    import ManagerDashboard from './components/ManagerDashboard';
    import AdminDashboard from './components/AdminDashboard';
    import DispatcherDashboard from './components/DispatcherDashboard';
    import CommercialDashboard from './components/CommercialDashboard';

    export default {
        components: {CCDashboard, ClientDashboard, ManagerDashboard, AdminDashboard, DispatcherDashboard, CommercialDashboard},
        computed: {
            activeUserInfo() {
                return this.$store.state.AppActiveUser
            }
        },
    }
</script>
